import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { NormalBlending } from 'three';
import BasicEmitter from './BasicSingleEmitter';
const OcclusionCoreAdditiveEmitter = ({ isPlaying, runCounter, duration, isStatic, id, emitter: emitterSettings, emitterGroup: emitterGroupSettings, position, rotation, scale, renderOrder, onFinish }) => {
    const occlusionGroupEmitterSettings = useMemo(() => {
        const settings = JSON.parse(JSON.stringify(emitterGroupSettings));
        settings.blending = NormalBlending;
        return settings;
    }, [emitterGroupSettings]);
    const occlusionEmitterSettings = useMemo(() => {
        const settings = JSON.parse(JSON.stringify(emitterSettings));
        settings.particleCount = Math.floor((settings?.particleCount || 1000) / 2);
        if (!settings.position)
            settings.position = {};
        const s = settings.position.spread;
        settings.position.spread = [s[0] - 0.1, s[1] - 0.11, s[2] - 0.1];
        settings.maxAge.value = settings.maxAge.value * 0.95;
        return settings;
    }, [emitterSettings]);
    return (_jsxs("group", { position: position, rotation: rotation, children: [_jsx(BasicEmitter, { id: id, position: [0, 0, 0], rotation: [0, 0, 0], scale: scale, renderOrder: renderOrder, isStatic: isStatic, duration: duration, isPlaying: isPlaying, runCounter: runCounter, onFinish: onFinish, emitter: occlusionEmitterSettings, emitterGroup: occlusionGroupEmitterSettings }), _jsx(BasicEmitter, { id: id, position: [0, 0, 0], rotation: [0, 0, 0], scale: scale, renderOrder: renderOrder, isStatic: isStatic, duration: duration, isPlaying: isPlaying, runCounter: runCounter, onFinish: onFinish, emitter: emitterSettings, emitterGroup: emitterGroupSettings })] }));
};
export default OcclusionCoreAdditiveEmitter;
